import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
/* HOCs */
import { connectedCalculateDealPaymentsByType } from 'site-modules/shared/components/car-buying/calculate-deal-payments-by-type/calculate-deal-payments-by-type';
/* Models */
import { InventoryEntities } from 'client/data/models/inventory';
/* Utils */
import { isUsed } from 'site-modules/shared/utils/inventory-utils/is-used';
/* Components */
import { VdpPricingChart } from 'site-modules/shared/components/vdp-pricing-chart/vdp-pricing-chart';

import './vdp-pricing-chart-connected.scss';

export function VdpPricingChartConnectedUI({
  vinData = null,
  deals = {},
  storedZipCode = '',
  isMobile = false,
  skipWidgetViewTracking = false,
  showLeasePayments = false,
  isLeasePaymentEnabled = false,
  useGraphQlForLoanOffers = false,
  isLeaseView = false,
  forceLease = false,
  withShadow = false,
}) {
  if (!vinData) return null;

  return (
    <div
      className={classnames('vdp-pricing-chart-connected mt-0_75 mt-md-2_5', {
        'with-shadow pb-0_75': withShadow,
      })}
    >
      <VdpPricingChart
        vinData={vinData}
        dealItems={deals}
        zipCode={storedZipCode}
        isMobile={isMobile}
        isUsed={isUsed(vinData.type)}
        skipWidgetViewTracking={skipWidgetViewTracking}
        isPurchase={!showLeasePayments}
        showLeasePayments={showLeasePayments}
        isLeasePaymentEnabled={isLeasePaymentEnabled}
        useGraphQlForLoanOffers={useGraphQlForLoanOffers}
        isLeaseView={isLeaseView}
        forceLease={forceLease}
      />
    </div>
  );
}

VdpPricingChartConnectedUI.propTypes = {
  vinData: InventoryEntities.InventoryVin,
  deals: PropTypes.shape({ [PropTypes.string]: PropTypes.arrayOf(PropTypes.shape({})) }),
  storedZipCode: PropTypes.string,
  isMobile: PropTypes.bool,
  skipWidgetViewTracking: PropTypes.bool,
  showLeasePayments: PropTypes.bool,
  isLeasePaymentEnabled: PropTypes.bool,
  useGraphQlForLoanOffers: PropTypes.bool,
  isLeaseView: PropTypes.bool,
  forceLease: PropTypes.bool,
  withShadow: PropTypes.bool,
};

export const VdpPricingChartConnected = connectedCalculateDealPaymentsByType(VdpPricingChartConnectedUI);
